export enum ServiceIds {
    hostedExchange = 1,
    bitDefender = 6,
    microsoft = 7,
    azure = 8,
    azurePlan = 42,
}
